import { webapi } from '@/api/webapi.ts';
import { cancelCashRfs } from '@/store/cash/api/cancelCashRfs.ts';
import { checkCashByTradeCapture } from '@/store/cash/api/checkCashByTradeCapture.ts';
import { executeCashEsp } from '@/store/cash/api/executeCashEsp.ts';
import { executeCashRfs } from '@/store/cash/api/executeCashRfs.ts';
import { getFixingReferences } from '@/store/cash/api/getFixingReferences.ts';
import { requestCashRfs } from '@/store/cash/api/requestCashRfs.ts';

export const cashApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkCashByTradeCapture: checkCashByTradeCapture(builder),
    // checkForward: checkForward(builder),
    // checkNdf: checkNdf(builder),

    executeCashEsp: executeCashEsp(builder),

    requestCashRfs: requestCashRfs(builder),
    executeCashRfs: executeCashRfs(builder),
    cancelCashRfs: cancelCashRfs(builder),

    getFixingReferences: getFixingReferences(builder),
  }),
});

export const {
  useCheckCashByTradeCaptureMutation,
  useExecuteCashEspMutation,
  useRequestCashRfsMutation,
  useExecuteCashRfsMutation,
  useCancelCashRfsMutation,
} = cashApi;

export const { initiate: initiateCheckCashByTradeCapture } = cashApi.endpoints.checkCashByTradeCapture;
